import { DatasetModel } from 'models/dataset.model';
import { ElementKind, ImageVariantElement } from 'models/editor.model';
import { VariantType } from 'models/variant.model';

const buildImageElement = (fieldText?: string) => {
    return {
        kind: ElementKind.image,
        variantType: VariantType.Image,
        children: [
            {
                text: fieldText ?? '',
            },
        ],
    };
};
const buildImageDatasetElement = (
    id: number,
    element: ImageVariantElement,
    datasetData: DatasetModel,
) => {
    return {
        ...element,
        children: [
            {
                text: datasetData?.fields?.find(
                    (field: { id: number }) => field.id === id,
                )?.sample,
            },
        ],
        datasetId: datasetData.id,
        datasetField: id,
    };
};

const buildEmailImageDatasetElement = (inputType: string) => {
    return {
        kind: ElementKind.section,
        sectionType: inputType,
        children: [{ text: '' }],
    };
};

export const newImageElement = (
    id?: number,
    fieldText?: string,
    element?: ImageVariantElement,
    datasetData?: DatasetModel,
    isEmail?: boolean,
    inputType?: string,
) => {
    if (id !== undefined && element && datasetData) {
        return buildImageDatasetElement(id, element, datasetData);
    } else if (isEmail && inputType) {
        return buildEmailImageDatasetElement(inputType);
    } else {
        return buildImageElement(fieldText);
    }
};
